import { ChangeEvent, useCallback, useEffect, useState } from 'react';

import { Checkbox } from 'components/Checkbox';
import { Input } from 'components/Input/Input';
import { InputType } from 'components/Input/InputProps';
import { RecaptchaInput } from 'components/RecaptchaInput';
import { SelectInput } from 'components/SelectInput';
import { configValue } from 'config/appConfigUtils';
import { CmsApiFormBuilderField } from 'modules/cms/api/types/blocks/CmsApiFormBuilderBlock';
import { trackEvent } from 'utils/analytics/track/trackEvent';

import { getCmsFormBuilderId } from './getCmsFormBuilderId';

export function CmsFormBuilderBlockField({
  field,
  action,
}: {
  field: CmsApiFormBuilderField;
  action: string;
}) {
  const [value, setValue] = useState('');
  const [checked, setChecked] = useState(false);
  const [changed, setChanged] = useState(false);
  const id = getCmsFormBuilderId(field.name);
  const inputProps = {};
  const trackChange = useCallback(() => {
    trackEvent('CMS Form Edited', {
      action,
      // TODO fix next line next time working on file
      // @ts-expect-error Error appeared when improving types
      label: field.label,
    });
    // TODO fix next line next time working on file
    // @ts-expect-error Error appeared when improving types
  }, [action, field.label]);
  useEffect(() => {
    if (changed) {
      trackChange();
    }
  }, [changed, trackChange]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setTextValue = (e: any) => {
    setValue(e);
    setChanged(true);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setSelectValue = (e: any) => {
    setValue(e);
    trackChange();
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updateChecked = (e: any) => {
    setChecked(e);
    trackChange();
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const setRecaptchaValue = (e: any) => {
    setValue(e);
    trackChange();
  };

  switch (field.type) {
    case 'SELECT':
      return (
        <SelectInput
          options={[
            {
              value: '',
              label: field.placeholder || getText('Select One'),
              disabled: true,
            },
            // @ts-expect-error TS(2769): No overload matches this call.
          ].concat(field.options || [])}
          onChange={setSelectValue}
          value={value}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...inputProps}
        />
      );

    case 'CHECKBOX':
      return (
        <Checkbox
          onChange={updateChecked}
          checked={checked}
          value={field.value}
          label={field.label}
          large
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...inputProps}
        />
      );

    case 'HIDDEN':
      return <input name={field.name} value={field.value} hidden />;

    case 'RECAPTCHA':
      return configValue('google', 'recaptcha', 'enabled') ? (
        <RecaptchaInput onChange={setRecaptchaValue} siteKey={field.siteKey} />
      ) : (
        <Checkbox
          onChange={updateChecked}
          checked={checked}
          value=""
          label="I'm not a robot"
          large
          name="gRecaptchaResponse"
          required
          data-qa-id={id}
        />
      );

    case 'TEXT':
    case 'EMAIL':
    default:
      return (
        <Input
          inputProps={{
            id,
            name: field.name,
            onChange: (e: ChangeEvent<HTMLInputElement>) =>
              setTextValue(e.target.value),
            onFocus: () => setChanged(false),
            placeholder: field.placeholder,
            qaId: id,
            required: field.required,
            type: field.type.toLowerCase() as InputType,
            value,
          }}
        />
      );
  }
}
